import Vue from 'vue'
import Vuex from 'vuex'
import bus from './assets/js/bus';

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        jwtToken: localStorage.getItem('jwt-token'),
        user: {
            countryName: "",
            currency: "",
            email: "",
            idNumber: "",
            jwtToken: "",
            language: "",
            merchant: "",
            orderConfirm: 0,
            phone: "",
            realname: "",
            phoneVerify: -1,//是否绑定手机号
            emailVerify: -1,//是否绑定邮箱
            statusGoogle:-1,//是否绑定谷歌验证
            phoneSecurity: -1,//是否开启手机验证
            emailSecurity: -1,//是否开启邮箱验证
            googleSecurity: -1,//是否开启谷歌验证
            status: 0,
            statusKyc: 0,
            statusKycLevel: 0,
            symbol: [],
            tickerColor: 0,
            tickerRefresh: 0,
            tranPassword: 0, // -1未设置交易密码, 1已设置交易密码
            userId: null,
            username: "",
            vipLevel: "", // register普通用户，member会员
            otcEmailAdvise: 0,
            otcPhoneAdvise: 0
        },
        appLan: localStorage.getItem('appLan') || 'zh-hk',
        kChartData: [],
        routerObject: null,
        littleAsset: 1,
        errorCode: {
            ok: '000000',
            jwtError: 'JWT001',
            jwtOutTime: 'JWT000',
            notLogin: 'VISAUTH001'
        },
        wsOrderData: []
    },
    mutations: {
        updateToken(state, val) {
            state.jwtToken = val;
        },
        updateAppLan(state, val) {
            state.appLan = val;
            localStorage.setItem('appLan', val)
        },
        //order数据
        updateWsOrderData(state, obj) {
            state.wsOrderData = obj;
        },
        //更新路由
        updateRouter(state, obj) {
            state.routerObject = obj;
        },
        //更新用户收藏交易对
        updateUserCollect(state, obj) {
            Object.keys(obj).forEach(function(value, index) {
                state.user.collect[index].push(value);
            });
        },
        //登录
        userLogin(state, obj) {
            state.user = obj;
        },
        //登出，重置用户信息
        removeLoginInfo(state) {
            state.jwtToken = ''
            state.user = {
                countryName: "",
                currency: "",
                email: "",
                emailVerify: 0,
                idNumber: "",
                jwtToken: "",
                language: "",
                merchant: "",
                orderConfirm: 0,
                phone: "",
                phoneVerify: 0,
                realname: "",
                status: 0,
                statusKyc: 0,
                symbol: [],
                tickerColor: 0,
                tickerRefresh: 0,
                tranPassword: 0,
                userId: 0,
                username: "",
                vipLevel: "" // register普通用户，member会员
            };
        },
        //更新用户收藏的交易对
        updateSymbol(state, obj) {
            if (obj.status === 1) {
                state.user.symbol.push(obj.symbol);
            } else {
                state.user.symbol.splice(state.user.symbol.indexOf(obj.symbol), 1);
            }
        },
        //修改交易验证开启状态
        updateTradeConfirm(state, type) {
            state.user.orderConfirm = type;
        }
    },
    actions: {
        /**
         * 登出
         * @param commit
         * @param state
         * @returns {Promise<any>}
         */
        actions_loginOut({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                if (window.localStorage.getItem('jwt-token')) {
                    window.$axios.post('/user/signOut', {}).then(res => {
                        window.localStorage.removeItem('jwt-token');
                        commit('removeLoginInfo');
                        resolve(res);
                    }).catch(error => {
                        reject(error);
                    })
                } else {
                    commit('removeLoginInfo');
                    resolve();
                }

            })
        },
        /**
         * 获取用户信息
         * @param commit
         * @param state
         * @returns {Promise<any>}
         */
        actions_getUserInfo({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                window.$axios.post('/user/getUserInfo', {}).then(res => {
                    if (res.data.code === state.errorCode.ok) {
                        commit('userLogin', res.data.data);
                        bus.$emit('updateSystemData'); //获取系统通知
                        resolve(res.data.code); //成功则返回成功code
                    } else {
                        resolve(res.data.code, res.data.msg); //失败则返回错误code
                    }
                }).catch(error => {
                    reject(error);
                })
            })
        }
    }
})